export default __webpack_public_path__ + "static/media/Flag_of_the_United_States.8a10cc51.svg";